// Shared error-formatting helpers.
//
// Why this exists: Supabase PostgrestError objects are plain objects, NOT
// Error instances. The natural-looking pattern
//
//   alert("Couldn't save: " + (e instanceof Error ? e.message : String(e)))
//
// stringifies a PostgrestError as "[object Object]" and hides the real cause.
// Saw this swallow a FK-violation + RLS bug on the warranty deal-detail tab on
// May 9, 2026 — three different writes all failed with [object Object] for
// what was actually a clean RLS / FK violation that should have been obvious.
//
// Use `fmtSupabaseError(e)` in every Supabase try/catch alert.
//
// PostgrestError shape (from @supabase/postgrest-js):
//   { message: string; details: string; hint: string; code: string }
// Storage and Auth errors are similar but sometimes only have `message`.

export function fmtSupabaseError(e: unknown): string {
  if (e instanceof Error) return e.message;
  if (typeof e === "object" && e !== null) {
    const o = e as { message?: string; details?: string; hint?: string; code?: string };
    const parts = [o.message, o.details, o.hint, o.code].filter(Boolean);
    if (parts.length > 0) return parts.join(" — ");
    try { return JSON.stringify(e); } catch { return "(unknown error)"; }
  }
  return String(e);
}
